import React from 'react';
import { ListItem } from '@mui/material';
import { cx } from '@emotion/css';
import { Icon, InfoIcon, Pin } from '../../../../../../../atoms';
import useStyles, { isAlwaysEnabledClassName, hasErrorClassName, isDisabledClassName, } from './EventSelectorCardItem.styles';
function EventSelectorCardItem(props) {
    const classes = useStyles();
    const handleClick = () => {
        props.onItemClick(props.event);
    };
    const renderPin = () => {
        const handlePinClick = (event) => {
            event.stopPropagation();
            event.preventDefault();
            if (!props.pinned) {
                props.onItemPin(props.event);
            }
            else {
                props.onItemUnpin(props.event);
            }
        };
        return (React.createElement("button", { className: cx({ [classes.hideUntilHover]: !props.pinned }), onClick: handlePinClick },
            React.createElement(Pin, { enabled: props.pinned, className: classes.pinIcon })));
    };
    const renderChevron = () => {
        return (React.createElement("div", null,
            React.createElement(Icon, { className: classes.chevronIcon }, "arrow_forward_ios")));
    };
    const renderRightActions = () => {
        return (React.createElement(React.Fragment, null,
            renderPin(),
            renderChevron()));
    };
    const renderInfoTooltip = () => {
        if (typeof props.event.disabled !== 'string' || !props.event.disabled) {
            return null;
        }
        const message = props.event.disabled;
        return React.createElement(InfoIcon, { className: classes.infoIcon, message: message });
    };
    const listItemId = props.event.alwaysEnabled
        ? 'list-item-always-enabled'
        : 'list-item';
    let disabledItemClass;
    if (props.event.alwaysEnabled) {
        disabledItemClass = isAlwaysEnabledClassName;
    }
    else if (props.event.disabled && props.selected) {
        disabledItemClass = hasErrorClassName;
    }
    else if (props.event.disabled) {
        disabledItemClass = isDisabledClassName;
    }
    return (React.createElement(ListItem, { id: listItemId, key: props.event.name, className: cx(classes.item, disabledItemClass, {
            [classes.itemSelected]: props.selected,
        }), onClick: handleClick },
        React.createElement("div", { className: classes.leftGroup },
            props.selected && React.createElement("span", { className: classes.itemSelectedBar }),
            React.createElement("div", { className: cx('list-item-label', classes.itemLabel), title: props.event.name }, props.event.name),
            renderInfoTooltip()),
        React.createElement("div", { className: classes.rightGroup }, renderRightActions())));
}
export default EventSelectorCardItem;
//# sourceMappingURL=EventSelectorCardItem.js.map